function setTab(name, cursel, n) {
  for (i = 1; i <= n; i++) {
    var menu = document.getElementById(name + i);
    var con = document.getElementById("con_" + name + "_" + i);
    menu.className = i == cursel ? "active" : "";
    con.style.display = i == cursel ? "block" : "none";
    con.style.visibility = i == cursel ? "visible" : "hidden";
  }
}
document.addEventListener("DOMContentLoaded", () => {
  $(document).ready(function () {
    $(".faq-page .faq_subbox .title").click(function () {
      $(this).next(".faq-box").slideToggle(600);
      $(this).toggleClass("selected");
    });
  });
});
